// extracted by mini-css-extract-plugin
export default {"imageWrapper":"QL-z","twoColumnImage":"RL-z"};